import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IResponseIdName } from '../globalQuery';

export const useRequestResearchLines = (selectiveProcessId: string, levelId?: string) =>
  useQuery({
    queryKey: ['registration_research_lines', selectiveProcessId, levelId],
    queryFn: async () => {
      const response = await configApi.get<IResponseIdName[]>('selective-process/research-line/', {
        params: {
          selective_process_id: selectiveProcessId,
          level_id: levelId,
        },
      });
      return response.data;
    },
    enabled: Boolean(selectiveProcessId && levelId),
    refetchOnWindowFocus: false,
  });

export const useRequestThematicAxes = (researchLineId?: string) =>
  useQuery({
    queryKey: ['registration_thematic_axes', researchLineId],
    queryFn: async () => {
      const response = await configApi.get<IResponseIdName[]>('selective-process/thematic-axis/', {
        params: { research_line_id: researchLineId, is_active: true, remove_pagination: true },
      });
      return response.data;
    },
    enabled: Boolean(researchLineId),
    refetchOnWindowFocus: false,
  });
